
import { Component, Vue, Prop } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class GrowthCamp extends Vue {
  metaInfo = {
    title: "我的页面标题", // 默认情况下，这将设置document的title属性。也可以设置为一个函数返回字符串或对象。
    meta: [
      // 这将设置或覆盖与组件关联的元数据。例如：设置viewport或描述等。
      { vmid: "description", name: "description", content: "这里是页面的描述" },
      { vmid: "keywords", name: "keywords", content: "这里是关键词" }
    ]
  };
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/e3e99f9a7a7fc03a657a479094712517.png";
  pic2 = "/img/8472cc555a16f46c5de2ceb8ee75d95c.png";
  pic3 = "/img/ab5f4d38299d660cf14ed2d2feb53fef.png";
  pic4 = "/img/2569e567ce58f92eb7c4cec27dcbfa2e.png";
  pic5 = "/img/647603baf18fbf956bad19ee024e61c4.png";
  pic6 = "/img/4bb0682da91d6941ee603a99f6da466f.png";
  pic7 = "/img/4bc88a3854a39e14ef05613d2eec2664.png";
  pic8 = "/img/6fb6447de6eeedf004b5ce7255e3b97b.png";
  pic9 = "/img/74e63a5beb6253144fa6aa087b4e82b5.png";

  result1 = "/gh_website/result1.png";
  companyArr: any = [];
  List = [
    { title: "BLM科学经营", url: "" },
    { title: "大增长营", url: "" }
  ];

  resultArr = [] as any;
  created() {
    this.initData();
  }
  initData() {
    this.resultArr = [];
    for (let index = 1; index < 9; index++) {
      this.resultArr.push("/gh_website/result" + index + ".png");
    }

    let companyArr0 = [];
    let companyArr1 = [];
    console.log(123456);
    for (let index = 1; index < 13; index++) {
      companyArr0.push("/gh_website/big-grow-activity" + index + ".png");
    }
    for (let index = 13; index < 25; index++) {
      companyArr1.push("/gh_website/big-grow-activity" + index + ".png");
    }

    console.log("companyArr0", companyArr0);
    console.log("companyArr1", companyArr1);
    this.companyArr.push(companyArr0);
    this.companyArr.push(companyArr1);
    console.log("companyArr", this.companyArr);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute("content", "BLM科学经营，大增长营，科研院");
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "以“科学经营”系统理论为底座，围绕企业高质量发展的核心，基于企业战略规划而设计学习方案，以终为始，有效学习，集中力量，高效学习，统一团队科学经营主线，助力企业力出一孔；BSC，BSC平衡积分卡，分拆对，业务视角、领导力，价值观，分目标，拆动作，对能力，差距分析，战略意图，市场洞察，创新焦点，业务设计，关键任务，正式组织，人才，市场结果，财务，客户，内部流程，学习与成长"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
